/* Custom theme JavaScript. Organized by feature. Safe to run more than once. */

(function () {
  if (window.customSizeConfirmInitialized) return;
  window.customSizeConfirmInitialized = true;

  var DISMISS_STORAGE_KEY = 'custom-size-confirm-dismissed';
  var pendingForm = null;
  var lastTrigger = null;

  function getModal() {
    return document.querySelector('[data-custom-size-confirm]');
  }

  function isDismissed() {
    try {
      return window.localStorage.getItem(DISMISS_STORAGE_KEY) === 'true';
    } catch (error) {
      return false;
    }
  }

  function saveDismissedPreference() {
    try {
      window.localStorage.setItem(DISMISS_STORAGE_KEY, 'true');
    } catch (error) {
      // The confirmation still works when browser storage is unavailable.
    }
  }

  function getFormScope(form) {
    return (form && form.closest && (form.closest('section') || form.closest('product-info'))) || document;
  }

  function productHasSizeOption(form) {
    var scope = getFormScope(form);
    var labels = scope.querySelectorAll('variant-radios fieldset legend, variant-selects label');
    for (var i = 0; i < labels.length; i++) {
      if (/^\s*size\s*$/i.test(labels[i].textContent.trim())) return true;
    }
    return false;
  }

  function getSelectedSize(form) {
    var scope = getFormScope(form);

    var fieldsets = scope.querySelectorAll('variant-radios fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (legend && /^\s*size\s*$/i.test(legend.textContent.trim())) {
        var checked = fieldsets[i].querySelector('input:checked');
        return checked ? checked.value : null;
      }
    }

    var selects = scope.querySelectorAll('variant-selects select');
    for (var j = 0; j < selects.length; j++) {
      var match = (selects[j].getAttribute('name') || '').match(/^options\[(.+)\]$/);
      if (match && match[1].toLowerCase() === 'size') return selects[j].value;
    }

    return null;
  }

  function setModalTitle(modal, size) {
    var title = modal.querySelector('[data-custom-size-title]');
    if (!title) return;
    title.textContent = '';
    if (size) {
      title.append(document.createTextNode('You\u2019ve selected size '));
      var strong = document.createElement('strong');
      strong.textContent = size;
      title.append(strong);
    } else {
      title.append(document.createTextNode('Are you sure this is your size?'));
    }
  }

  function resetGuideAccordion(modal) {
    var toggle = modal.querySelector('[data-custom-size-guide-toggle]');
    var body = modal.querySelector('[data-custom-size-guide-body]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (body) body.hidden = true;
  }

  function showModal(form) {
    var modal = getModal();
    if (!modal) return;
    setModalTitle(modal, getSelectedSize(form));
    resetGuideAccordion(modal);
    var dismissCheckbox = modal.querySelector('[data-custom-size-confirm-dismiss]');
    if (dismissCheckbox) dismissCheckbox.checked = false;
    modal.hidden = false;
    document.body.classList.add('overflow-hidden');
    var focusTarget =
      modal.querySelector('[data-custom-size-confirm-continue]') ||
      modal.querySelector('.custom-size-confirm__close');
    if (focusTarget && focusTarget.focus) focusTarget.focus();
  }

  function hideModal() {
    var modal = getModal();
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('overflow-hidden');
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
    lastTrigger = null;
  }

  function isOpen() {
    var modal = getModal();
    return Boolean(modal && !modal.hidden);
  }

  // Capture phase so we run before product-form's own submit handler.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.getAttribute('data-type') !== 'add-to-cart-form') return;

      // Already confirmed via the modal: let the normal Add to Cart flow run once.
      if (form.dataset.customSizeConfirmed === 'true') {
        delete form.dataset.customSizeConfirmed;
        return;
      }

      // Only interrupt products with a Size option so gift cards and
      // one-size products keep the existing cart experience.
      if (!productHasSizeOption(form)) return;
      if (isDismissed()) return;

      // If the modal is already open, ignore extra submits.
      if (isOpen()) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      pendingForm = form;
      lastTrigger = document.activeElement;
      showModal(form);
    },
    true
  );

  function continueToCart() {
    var form = pendingForm;
    var modal = getModal();
    var dismissCheckbox = modal && modal.querySelector('[data-custom-size-confirm-dismiss]');
    if (dismissCheckbox && dismissCheckbox.checked) saveDismissedPreference();
    pendingForm = null;
    hideModal();
    if (!form) return;
    form.dataset.customSizeConfirmed = 'true';
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }

  function cancel() {
    pendingForm = null;
    hideModal();
  }

  document.addEventListener('click', function (event) {
    var guideToggle = event.target.closest('[data-custom-size-guide-toggle]');
    if (guideToggle) {
      var expanded = guideToggle.getAttribute('aria-expanded') === 'true';
      var body = document.getElementById(guideToggle.getAttribute('aria-controls'));
      guideToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (body) body.hidden = expanded;
      return;
    }

    var continueButton = event.target.closest('[data-custom-size-confirm-continue]');
    if (continueButton) {
      event.preventDefault();
      continueToCart();
      return;
    }

    var closeButton = event.target.closest('[data-custom-size-confirm-close]');
    if (closeButton) {
      cancel();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (isOpen()) cancel();
  });
})();

class CustomImageGalleryCarousel extends HTMLElement {
  connectedCallback() {
    if (this.abortController) return;

    this.slides = Array.from(this.querySelectorAll('[data-custom-image-gallery-slide]'));
    if (!this.slides.length) return;

    this.items = Array.from(this.querySelectorAll('[data-custom-image-gallery-item]'));
    this.dots = Array.from(this.querySelectorAll('[data-custom-image-gallery-dot]'));
    this.desktopMedia = window.matchMedia('(min-width: 750px)');
    this.reducedMotionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.itemsPerPage = this.desktopMedia.matches ? 4 : 6;
    this.pageIndex = 0;
    this.autoplayInterval = Number(this.dataset.autoplayInterval) || 4000;
    this.touchStartX = null;
    this.abortController = new AbortController();

    var signal = this.abortController.signal;
    var carousel = this;

    this.dots.forEach(function (dot) {
      dot.addEventListener(
        'click',
        function () {
          carousel.goToPage(Number(dot.dataset.page), true);
        },
        { signal: signal }
      );
    });

    this.addEventListener('keydown', this.handleKeydown.bind(this), { signal: signal });
    this.addEventListener('mouseenter', this.stopAutoplay.bind(this), { signal: signal });
    this.addEventListener('mouseleave', this.startAutoplay.bind(this), { signal: signal });
    this.addEventListener('focusin', this.stopAutoplay.bind(this), { signal: signal });
    this.addEventListener('focusout', this.handleFocusOut.bind(this), { signal: signal });
    this.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true, signal: signal });
    this.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true, signal: signal });
    this.addEventListener('shopify:block:select', this.handleBlockSelect.bind(this), { signal: signal });
    document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this), { signal: signal });

    this.handleBreakpointChangeBound = this.handleBreakpointChange.bind(this);
    if (this.desktopMedia.addEventListener) {
      this.desktopMedia.addEventListener('change', this.handleBreakpointChangeBound);
    } else {
      this.desktopMedia.addListener(this.handleBreakpointChangeBound);
    }

    this.setAttribute('data-ready', '');
    this.updateSlides();
    this.startAutoplay();
  }

  disconnectedCallback() {
    this.stopAutoplay();
    if (this.abortController) this.abortController.abort();
    this.abortController = null;

    if (!this.desktopMedia || !this.handleBreakpointChangeBound) return;
    if (this.desktopMedia.removeEventListener) {
      this.desktopMedia.removeEventListener('change', this.handleBreakpointChangeBound);
    } else {
      this.desktopMedia.removeListener(this.handleBreakpointChangeBound);
    }
  }

  get pageCount() {
    return Math.ceil(this.items.length / this.itemsPerPage);
  }

  updateSlides() {
    var isDesktop = this.desktopMedia.matches;
    var firstVisibleItem = this.pageIndex * this.itemsPerPage;
    var lastVisibleItem = firstVisibleItem + this.itemsPerPage;

    this.items.forEach(function (item, index) {
      var isActive = !isDesktop && index >= firstVisibleItem && index < lastVisibleItem;
      item.classList.toggle('is-active', isActive);

      if (isDesktop) {
        item.removeAttribute('aria-hidden');
        item.removeAttribute('inert');
      } else {
        item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        item.toggleAttribute('inert', !isActive);
      }
    });

    this.slides.forEach(function (slide, index) {
      var isActive = isDesktop ? index === this.pageIndex : Boolean(slide.querySelector('.custom-image-gallery__item.is-active'));
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      slide.toggleAttribute('inert', !isActive);
    }, this);

    var activePage = this.pageIndex;
    this.dots.forEach(function (dot) {
      var isActive = Number(dot.dataset.page) === activePage;
      dot.classList.toggle('is-active', isActive);
      if (isActive) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }

  goToPage(pageIndex, userInitiated) {
    if (this.pageCount < 2) return;
    this.pageIndex = (pageIndex + this.pageCount) % this.pageCount;
    this.updateSlides();
    if (userInitiated) this.restartAutoplay();
  }

  startAutoplay() {
    this.stopAutoplay();
    if (
      this.pageCount < 2 ||
      this.reducedMotionMedia.matches ||
      document.hidden ||
      this.matches(':hover') ||
      this.contains(document.activeElement)
    ) {
      return;
    }

    var carousel = this;
    this.autoplayTimer = window.setInterval(function () {
      carousel.goToPage(carousel.pageIndex + 1, false);
    }, this.autoplayInterval);
  }

  stopAutoplay() {
    if (!this.autoplayTimer) return;
    window.clearInterval(this.autoplayTimer);
    this.autoplayTimer = null;
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }

  handleBreakpointChange() {
    var firstVisibleItem = this.pageIndex * this.itemsPerPage;
    this.itemsPerPage = this.desktopMedia.matches ? 4 : 6;
    this.pageIndex = Math.floor(firstVisibleItem / this.itemsPerPage);
    this.updateSlides();
    this.restartAutoplay();
  }

  handleKeydown(event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    this.goToPage(this.pageIndex + (event.key === 'ArrowRight' ? 1 : -1), true);
  }

  handleFocusOut(event) {
    if (event.relatedTarget && this.contains(event.relatedTarget)) return;
    this.startAutoplay();
  }

  handleTouchStart(event) {
    this.touchStartX = event.touches[0] ? event.touches[0].clientX : null;
    this.stopAutoplay();
  }

  handleTouchEnd(event) {
    if (this.touchStartX === null || !event.changedTouches[0]) {
      this.startAutoplay();
      return;
    }

    var distance = event.changedTouches[0].clientX - this.touchStartX;
    this.touchStartX = null;
    if (Math.abs(distance) > 40) {
      this.goToPage(this.pageIndex + (distance < 0 ? 1 : -1), true);
    } else {
      this.startAutoplay();
    }
  }

  handleVisibilityChange() {
    if (document.hidden) {
      this.stopAutoplay();
    } else {
      this.startAutoplay();
    }
  }

  handleBlockSelect(event) {
    var slide = event.target.closest('[data-custom-image-gallery-slide]');
    var slideIndex = this.slides.indexOf(slide);
    if (slideIndex < 0) return;
    this.pageIndex = Math.floor((slideIndex * 4) / this.itemsPerPage);
    this.updateSlides();
    this.stopAutoplay();
  }
}

if (!customElements.get('custom-image-gallery-carousel')) {
  customElements.define('custom-image-gallery-carousel', CustomImageGalleryCarousel);
}
